import NETWORKS from '../definitions/Networks';


// this simple structure and its helper function take advantage of the fact
// that the names of all of the current networks are the same in EN and in FR
const NETWORK_NAMES = {
    [NETWORKS.AMEX]: 'American Express',
    [NETWORKS.MASTERCARD]: 'Mastercard',
    [NETWORKS.VISA]: 'VISA',
};

/**
 * get language-specific name for a CC network
 * @param {object} cardInfo
 * @param {cardInfo.string} network EN slug of CC network
 * @param {string} language currently irrelevant, it is present for future compatibility
 * @return {string} CC network name
 */
// eslint-disable-next-line no-unused-vars
export default function getCardNetworkName({ network }, language) {
    return NETWORK_NAMES[network];
}
